module.exports = __webpack_public_path__ + "static/Logo_zaliasis_taskas-f571998536d2ee1b4e47012465d6c4b2.png";